var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ordersEnhanced.length
    ? _c(
        "div",
        { staticClass: "order-state" },
        [
          _c(
            "vue-glide",
            _vm._b(
              {
                staticClass: "order-state__slider",
                model: {
                  value: _vm.activeSlide,
                  callback: function($$v) {
                    _vm.activeSlide = $$v
                  },
                  expression: "activeSlide"
                }
              },
              "vue-glide",
              _vm.glideOptionsEnhanced,
              false
            ),
            _vm._l(_vm.ordersEnhanced, function(order) {
              return _c(
                "vue-glide-slide",
                {
                  key: order.tokenValue,
                  staticClass: "order-state__slide",
                  class: ["order-state__slide--step-" + order.step]
                },
                [
                  _vm.showMap(order)
                    ? _c("MapLocations", {
                        ref: "map",
                        refInFor: true,
                        staticClass: "order-state__slide-map",
                        attrs: {
                          id: order.tokenValue,
                          "map-attributes": order.mapAttributes,
                          locations: order.locations
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "order-state__slide-wrapper" }, [
                    _c("div", { staticClass: "order-state__slide-animation" }, [
                      _c(
                        "div",
                        { staticClass: "order-state__slide-animation-wrapper" },
                        [
                          _c(
                            "svg",
                            {
                              staticClass:
                                "order-state__slide-animation-progress",
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "132",
                                height: "132",
                                fill: "none",
                                viewBox: "0 0 132 132"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d:
                                    "M2.43 58.09h.19c1.19 0 2.18-.88 2.36-2.06C9.02 30.12 29.29 9.51 55.03 4.96c1.17-.21 2.04-1.2 2.04-2.39v-.13c0-1.51-1.36-2.66-2.85-2.4C26.35 4.93 4.4 27.24.03 55.29c-.23 1.47.91 2.8 2.4 2.8Z",
                                  fill: "var(--status-segment-4, currentColor)"
                                }
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d:
                                    "M2.851 75.48h.18l-.01.01a2.41 2.41 0 0 1 2.36 1.97c4.88 24.82 24.71 44.33 49.7 48.72 1.15.2 1.98 1.23 1.98 2.4v.12c0 1.51-1.37 2.65-2.86 2.39-27.02-4.75-48.48-25.86-53.74-52.7-.29-1.51.86-2.91 2.39-2.91Z",
                                  fill: "var(--status-segment-3, currentColor)"
                                }
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d:
                                    "M74.461 128.57v.12a2.431 2.431 0 0 0 2.86 2.39c27.02-4.75 48.48-25.85 53.74-52.69.29-1.5-.85-2.91-2.39-2.91h-.18c-1.16 0-2.13.83-2.36 1.97-4.88 24.82-24.71 44.32-49.7 48.71-1.15.2-1.98 1.23-1.98 2.4l.01.01Z",
                                  fill: "var(--status-segment-2, currentColor)"
                                }
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d:
                                    "M74.459 2.44v.14c0 1.19.87 2.19 2.04 2.39 25.741 4.55 46.011 25.15 50.051 51.07.18 1.18 1.17 2.06 2.36 2.06h.18c1.49 0 2.63-1.33 2.4-2.8C127.13 27.24 105.18 4.94 77.31.04a2.44 2.44 0 0 0-2.851 2.4Z",
                                  fill: "var(--status-segment-1, currentColor)"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "order-state__slide-animation-player"
                            },
                            [
                              _c("lottie-vue-player", {
                                key: order.number + "-" + order.state,
                                attrs: {
                                  src: _vm.themeFilesPath(
                                    "lottie/" +
                                      (order.stateConfig.lottieFile ||
                                        _vm.lottieFile)
                                  ),
                                  autoplay: "",
                                  loop: ""
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "order-state__slide-animation-steps",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("orderstate.step", {
                              step: order.step,
                              steps: _vm.states.length
                            })
                          )
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "order-state__slide-title",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("orderstate.states." + order.stateConfig.state)
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "order-state__slide-details" }, [
                      _c("div", { staticClass: "order-state__slide-row" }, [
                        _c("div", {
                          staticClass: "order-state__slide-channel",
                          domProps: { innerHTML: _vm._s(order.channel.name) }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "order-state__slide-row" }, [
                        _c("a", {
                          staticClass: "order-state__slide-number",
                          attrs: { href: order.url, target: "_blank" },
                          domProps: { innerHTML: _vm._s(order.number) }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "order-state__slide-date",
                          domProps: { innerHTML: _vm._s(order.date) }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "order-state__slide-row" }, [
                        _c("div", {
                          staticClass: "order-state__slide-method",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("orderstate." + order.shippingCode)
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "order-state__slide-items",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$tc("orderstate.items", order.itemCount, {
                                count: order.itemCount
                              })
                            )
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "order-state__slide-row" }, [
                        _c("div", {
                          staticClass: "order-state__slide-price",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$options.filters.fwgpricecent(
                                order.total,
                                "html"
                              )
                            )
                          }
                        })
                      ])
                    ])
                  ])
                ],
                1
              )
            }),
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }